import { render, staticRenderFns } from "./PricesDelivery.vue?vue&type=template&id=827d777c&scoped=true&"
import script from "./PricesDelivery.vue?vue&type=script&lang=js&"
export * from "./PricesDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827d777c",
  null
  
)

export default component.exports